<script lang="ts">
    import {onMount} from "svelte";
    import FontAwesomeView from "../Image/FontAwesomeView.svelte";
    import HoverTipsView from "../Message/HoverTipsView.svelte";

    export let label: string;
    export let value: string;
    export let valueUrl: string = null;

    export let hoverTipsMessage = null;
    export let hoverValueTipsMessage = null;


    onMount(() => {
    });


</script>

<span class="label-value-view">
    <span class="label">
        { label }

        {#if hoverTipsMessage != null}
            <HoverTipsView inversionColor={true} message={hoverTipsMessage}/>
        {/if}

    </span>
    <span class="value">
        {#if value != null}
            {#if valueUrl != null}
                <a href={valueUrl} target="_blank" rel="noreferrer noopenner">
                    { value }
                    <FontAwesomeView icon="external-link"/>
                </a>
            {:else}
                { value }
            {/if}
        {:else}
            <span class="no-data">なし</span>
        {/if}

        {#if hoverValueTipsMessage != null}
            <HoverTipsView message={hoverValueTipsMessage}/>
        {/if}
    </span>

</span>
<style lang="scss">
    .label-value-view {
        border-style: solid;
        border-width: 1px;
        border-color: var(--label-value-label-background-color);
        font-size: 0.7em;

        white-space: nowrap;
        display: inline-flex;

        .label {
            background-color: var(--label-value-label-background-color);
            color: var(--label-value-label-text-color);
            padding-left: 0.5em;
            padding-right: 0.5em;
        }

        .value {
            color: var(--label-value-label-background-color);
            background-color: var(--label-value-label-text-color);
            padding-left: 0.5em;
            padding-right: 0.5em;

            word-break: break-all;
            white-space: pre-wrap;

            .no-data {
                opacity: 0.5;
            }

        }

    }
</style>